import React from 'react';
import { TimeMark } from '../StyledPrimitives/StyledPrimitives';

const GameSummary = (props) => (
    <div>
        <h1>{props.game.job} <TimeMark>{props.game.years}</TimeMark></h1>
        <h4>{props.game.typeAndPlatform}</h4>
        <h4>as {props.game.title}</h4>
        <h4>with {props.game.collaborators}</h4>
    </div>
);

export default GameSummary;


// WEBPACK FOOTER //
// ./src/components/GameInfo/GameSummary.js